import {LoadingSkeleton} from '@github-ui/skeleton/LoadingSkeleton'
import {testIdProps} from '@github-ui/test-id-props'
import {memo} from 'react'
import diffStyles from '@github-ui/diff-lines/Diff.module.css'
import {useUserDiffViewSettingsData} from '@github-ui/diff-view-settings/page-data/payloads/diff-view-settings'

export const DiffEntryLoadingSkeleton = memo(function DiffEntryLoadingSkeleton({
  ariaLabel,
  testId,
  id,
  approximateLineCount = 5,
  approximateDiffHeight,
  maximumSkeletonHeight,
}: {
  ariaLabel: string
  testId: string
  id?: string
  approximateLineCount?: number
  approximateDiffHeight?: number // in pixels
  maximumSkeletonHeight?: number // in pixels
}) {
  const {data: settings} = useUserDiffViewSettingsData()
  const heightPerLine = settings?.lineSpacing === 'compact' ? 20 : 25
  const height = approximateDiffHeight ?? heightPerLine * approximateLineCount
  const finalHeight = maximumSkeletonHeight ? Math.min(height, maximumSkeletonHeight) : height

  return (
    <div className={diffStyles.diffTargetable} role="region" aria-label={ariaLabel} {...testIdProps(testId)} id={id}>
      <div className="border borderColor-muted">
        <div className="d-flex flex-column gap-2 p-3" style={{minHeight: finalHeight}}>
          <LoadingSkeleton height={'sm'} variant="rounded" width="random" />
          <LoadingSkeleton height={'sm'} variant="rounded" width="random" />
          <LoadingSkeleton height={'sm'} variant="rounded" width="random" />
          <LoadingSkeleton height={'sm'} variant="rounded" width="random" />
        </div>
      </div>
    </div>
  )
})
